import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\FetchEventActivitiesByIdController::__invoke
* @see app/Http/Controllers/Planning/FetchEventActivitiesByIdController.php
* @route '/api/planning/{event}/activities'
*/
const FetchEventActivitiesByIdController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchEventActivitiesByIdController.url(args, options),
    method: 'get',
})

FetchEventActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/planning/{event}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Planning\FetchEventActivitiesByIdController::__invoke
* @see app/Http/Controllers/Planning/FetchEventActivitiesByIdController.php
* @route '/api/planning/{event}/activities'
*/
FetchEventActivitiesByIdController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return FetchEventActivitiesByIdController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\FetchEventActivitiesByIdController::__invoke
* @see app/Http/Controllers/Planning/FetchEventActivitiesByIdController.php
* @route '/api/planning/{event}/activities'
*/
FetchEventActivitiesByIdController.get = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchEventActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Planning\FetchEventActivitiesByIdController::__invoke
* @see app/Http/Controllers/Planning/FetchEventActivitiesByIdController.php
* @route '/api/planning/{event}/activities'
*/
FetchEventActivitiesByIdController.head = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchEventActivitiesByIdController.url(args, options),
    method: 'head',
})

export default FetchEventActivitiesByIdController